import { useEffect, useMemo, useState } from 'react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import ResourcePersonListTable from './tables/ResourcePersonListTable';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { clearTable, handleTableData } from '../../../../../Redux/slices/table';
import { useDispatch } from 'react-redux';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import UserImage from '../../../../../Components/UserImage';
import ToolTip from '../../../../../Components/ToolTip';
import { toNepaliNumber } from '../../../../../_helpers/_methods';

function ResourcePersonModal({
  show,
  resourcePersons,
  sessionId,
  action,
  handleClose,
  handleRemoveResourcePerson
}) {
  const { id } = useParams();
  const local = useSelector((state) => state.local.local);
  const intl = useIntl();

  const [selectedResourcePersons, setSelectedResourcePersons] = useState([]);

  useEffect(() => {
    setSelectedResourcePersons(resourcePersons);
  }, [resourcePersons]);

  const dispatch = useDispatch();
  const results = useSelector((state) => state.table.results);
  const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = useMemo(() => {
      const options = new Set();
      preFilteredRows.forEach((row) => {
        options.add(row.values[id]);
      });
      return [...options.values()];
    }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}>
        <option value="">All</option>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  };

  const dataFetcher = ({ index }) => {
    dispatch(
      handleTableData({
        url: `/event/${id}/resource-persons/?limit=50&approved=true`,
        index: index
      })
    );
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        disableFilters: true,
        width: '40px'
      },
      {
        Header: <FormattedMessage id="event.userFullName" />,
        accessor: 'fullname',
        Cell: ({ row: { original }, cell: { value } }) => {
          return (
            <Link
              to={`/admin/rosters/profile/${original.id}`}
              className="d-flex align-items-center ">
              <div className="me-1 position-relative">
                <UserImage avatar={original.image} userName={value} userId={String(original.id)} />
                <span className="avatar-profile-iscomplete-badge">
                  {original.warnings && (
                    <ToolTip
                      warnings={original.warnings}
                      isComplete={original.is_profile_updated}
                    />
                  )}
                </span>
              </div>
              <span className="d-block">
                {value} <br />
                <small>{original.office_name && original.office_name}</small>
              </span>
              {original.suspended && <Badge bg="danger">Suspended</Badge>}
            </Link>
          );
        },
        width: '170px'
      },
      {
        Header: <FormattedMessage id="event.userPhone" />,
        accessor: 'mobile_number',
        width: '100px'
      },
      {
        Header: <FormattedMessage id="event.userAddress" />,
        accessor: 'address',
        width: '170px'
      },
      {
        Header: <FormattedMessage id="event.gender" />,
        accessor: 'gender',
        Filter: SelectColumnFilter,
        filter: 'equals',
        width: '50px'
      },
      {
        Header: <FormattedMessage id="event.pan" />,
        accessor: 'pan',
        width: '120px'
      },
      {
        Header: <FormattedMessage id="event.resourcepersonType" />,
        accessor: 'type',
        width: '100px'
      },
      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions',
        disableFilters: true,
        Cell: ({ row: { original } }) => {
          return (
            <span className="d-flex align-items-center">
              {selectedResourcePersons.findIndex((item) => item.user === original.user) >= 0 ? (
                <>
                  <span className="text-success">
                    <FormattedMessage id="selected" />
                  </span>

                  <Button
                    variant="outline-danger"
                    className="ms-2"
                    size="sm"
                    onClick={() => handleRemoveResourcePerson(original.id)}>
                    <FormattedMessage id="button.remove" />
                  </Button>
                </>
              ) : (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleResourcePersonAdd(original)}>
                  <FormattedMessage id="button.add" />
                </Button>
              )}
            </span>
          );
        }
      }
    ],
    [selectedResourcePersons]
  );

  const data = useMemo(() => {
    if (!results) return [];

    let count = 1;
    return results.map((result) => {
      return {
        serial_number: local === 'ne' ? toNepaliNumber(count++) : count++,
        fullname: result.fullname,
        mobile_number: result.phone
          ? local === 'ne'
            ? toNepaliNumber(result.phone)
            : result.phone
          : 'not availiable',
        address: result.address,
        gender: intl.formatMessage({ id: result.gender || 'p' }),
        pan: result.pan
          ? local === 'ne'
            ? toNepaliNumber(result.pan)
            : result.pan
          : 'not availiable',
        type: intl.formatMessage({ id: result.type || 'p' }),
        id: result.id,
        warnings: result.warnings,
        user: result.user,
        is_profile_updated: result.is_profile_updated,
        image: result.image
      };
    });
  }, [results]);

  const getSelectedParticipants = async () => {
    try {
      // assigned to event wala resoruce api rakne
      const response = await fetchWrapper.get(
        `/event/session/${sessionId}/resource-person/?limit=50`
      );
      setSelectedResourcePersons(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    try {
      if (sessionId) {
        getSelectedParticipants();
      }
    } catch (err) {
      console.log(err);
    }
  }, []);
  const handleResourcePersonAdd = async (selectedOne) => {
    try {
      if (action) {
        action([selectedOne]);
      } else {
        toast.success(<FormattedMessage id="event.resourcePersonAdded" />);
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong');
    }
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg" className="custom-modal">
      <Modal.Header closeButton centered>
        <Modal.Title>
          <FormattedMessage id={'resource_person_roster'} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ResourcePersonListTable data={data} columns={columns} dataFetcher={dataFetcher} />
        <div className="d-flex justify-content-center">
          <Button onClick={handleClose} variant="outline-primary">
            <FormattedMessage id="button.close" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ResourcePersonModal;
